import type { CSSProperties } from 'react'

import cn from '@config/tailwind/cn'

const SHAPES = {
  a: '58% 42% 55% 45% / 48% 58% 42% 52%',
  b: '45% 55% 40% 60% / 55% 45% 60% 40%',
} as const

interface BlobProps {
  /** A color token class, e.g. bg-blue-20. */
  color: string
  width: number
  height: number
  /** Offsets in px from the section edges, as in the design file. */
  position: Pick<CSSProperties, 'top' | 'bottom' | 'left' | 'right'>
  shape?: keyof typeof SHAPES
}

/** A soft shape behind a section edge; the parent section needs `relative isolate`. */
export function Blob({ color, width, height, position, shape = 'a' }: BlobProps) {
  const origin = `${position.left !== undefined ? 'left' : 'right'} ${position.top !== undefined ? 'top' : 'bottom'}`

  return (
    <div
      aria-hidden='true'
      className={cn('pointer-events-none absolute -z-10 max-md:scale-55', color)}
      style={{ width, height, borderRadius: SHAPES[shape], transformOrigin: origin, ...position }}
    />
  )
}
